 import ApiService from "@/core/services/api.service";
 import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    async prepararAlteracaoMultiplaFluxo(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada');
        ApiService.setHeader();
        const {data} = await ApiService.postOnce('fluxoDeCaixa/access/prepararAlteracaoMultipla', dados, {timeout: 60000});
        if (data?.ERRO || !Array.isArray(data?.REGISTROS) || !data?.DESTINOS)
            throw new Error(data?.MENSAGEM || 'Não foi possível consultar os títulos.');
        return data;
    },
    async salvarAlteracaoMultiplaFluxo(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada');
        ApiService.setHeader();
        // Não repetir automaticamente uma requisição de alteração em caso de falha de conexão.
        const {data} = await ApiService.postOnce('fluxoDeCaixa/access/salvarAlteracaoMultipla', dados, {timeout: 120000});
        if (data?.ERRO || !Array.isArray(data?.CONCLUIDOS) || !Array.isArray(data?.FALHAS))
            throw new Error(data?.MENSAGEM || 'Não foi possível confirmar a alteração. Atualize a seleção para conferir os títulos.');
        return data;
    },
    async prepararCopiaTitulo(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada');
        ApiService.setHeader();
        const { data: permissao } = await ApiService.post('security/access/obterPermissao', { TAREFA: 'CSMMOFLI' });
        if (![true, 1, '1'].includes(permissao?.PERMITIDO)) return { PERMITIDO: false };
        const { data } = await ApiService.post('fluxoDeCaixa/access/obterSimplesPorId', dados);
        return { PERMITIDO: true, TITULO: data };
    },
    async getFluxoDeCaixa(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada');
        if (!dados.pagina || !dados.quantidadePorPagina) {
            dados.pagina = 1;
            dados.quantidadePorPagina = 25;
        }
        ApiService.setHeader();
        const { data } = await ApiService.post("fluxoDeCaixa/access/listar", dados);
        return data;
    },
    getEmpresasUsuario(context, dados) {
        return new Promise(resolve => {
            if(JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("fluxoDeCaixa/access/empresasUsuario", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    salvaFluxoDeCaixa(context, dados) {
        return new Promise(resolve => {
            if(JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("fluxoDeCaixa/access/salvar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    deleteFluxoDeCaixa(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("fluxoDeCaixa/access/excluir", { ID_FLUXO_DE_CAIXA: dados.id, componente: dados.componente }).then(({ data }) => {
                        resolve(data);
                });
            }
        });
    },
    getFluxoDeCaixaMovimentoRelacionamento(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("fluxoDeCaixa/access/fluxoDeCaixaRelacionamentoMovimento", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    deleteFluxoDeCaixaPagamento(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("fluxoDeCaixa/access/cancelarPagamento", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getFluxoDeCaixaIndicadores(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("fluxoDeCaixa/access/fluxoDeCaixaIndicadores", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getFluxoDeCaixaDRE(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("fluxoDeCaixa/access/listarDRE", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getFluxoDeCaixaParcelas(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("fluxoDeCaixa/access/fluxoDeCaixaParcelas", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getFluxoDeCaixaNotasFiscais(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("fluxoDeCaixa/access/fluxoDeCaixaNotasFiscais", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getFluxoDeCaixaRateio(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("fluxoDeCaixa/access/fluxoDeCaixaRateio", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    salvarFluxoRelacionamento(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("fluxoDeCaixa/access/salvarFluxoRelacionamento", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    async gerarLinkPgtoFluxoBancoDoBrasil(context, dados) {
        if (!JwtService.getToken()) {
            throw new Error("Entre novamente para gerar o link de pagamento.");
        }
        ApiService.setHeader();
        // O endpoint legado gera o link no Banco do Brasil; não repetir em caso de falha de rede.
        const { data } = await ApiService.postOnce("fluxoDeCaixa/access/gerarLinkPgto", dados);
        return data;
    },
    getRepasseFluxoDeCaixa(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("fluxoDeCaixa/access/listarRepassePorFluxoDeCaixa",dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    async getFluxo(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada');
        ApiService.setHeader();
        const {data} = await ApiService.postOnce('fluxoDeCaixa/access/obterSimplesPorId', dados, {timeout:60000});
        if (!data?.ID_FLUXO_DE_CAIXA) throw new Error('Não foi possível consultar o título.');
        return data;
    },
    getFluxoPrimParc(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("fluxoDeCaixa/access/obterIdPrimParc",dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getFluxoTodosRelacionamentos(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("fluxoDeCaixa/access/listarFluxoTodosRelacionamentos",dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getEnviarEmailFluxo(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("fluxoDeCaixa/access/enviarEmailCobranca", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    postPagamentoMultiplo(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("fluxoDeCaixa/access/pagamentoMultiplo", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    deletePixGerado(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("fluxoDeCaixa/access/excluirPixGerado", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getFluxoPorIdRelacionamento(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("fluxoDeCaixa/access/listarFluxoPorIdRelacionamento", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
